module.exports = __webpack_public_path__ + "media/country_flags/ws-a68381b2.png";